<template>
  <v-app-bar
    app
    color="primary"
    dark
  >
    <v-btn
      class="text--white btn ml-5"
      text
      to="/"
    >
      <v-icon>{{ mdiHome }}</v-icon>
      Home
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="text--white btn ml-5"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-2">{{ mdiVideoInputComponent }}</v-icon>
          Components
        </v-btn>
      </template>
      <v-list>
        <slot name="components" />
        <v-list-item
          v-for="view in routerComponents"
          :key="view.name"
          :to="{ name: view.name }"
        >
          <v-list-item-title>{{view.routeName}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu offset-y class="ml-10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="text--white ml-5"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-2">{{ mdiBookOpenPageVariant }}</v-icon>
          Views
        </v-btn>
      </template>
      <v-list>
        <slot name="views" />
        <v-list-item
          v-for="view in routerViews"
          :key="view.name"
          :to="{ name: view.name }"
        >
          <v-list-item-title>{{view.routeName}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-spacer />
    <LocaleSwitcher />
  </v-app-bar>
</template>

<script>
import { mdiBookOpenPageVariant, mdiHome, mdiVideoInputComponent } from '@mdi/js';
import routerHelpers from '../router/helpers';
import LocaleSwitcher from './LocaleSwitcher.vue';

export default {
  name: 'ModuleAppBar',
  components: {
    LocaleSwitcher,
  },
  props: {
    components: {
      type: Object,
      default: () => {},
    },
    moduleName: {
      type: String,
      default: 'views',
    },
    views: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mdiBookOpenPageVariant,
      mdiHome,
      mdiVideoInputComponent,
    };
  },
  computed: {
    routerComponents() {
      return [...routerHelpers.mapViews('components', this.components)].map(this.mapLink);
    },
    routerViews() {
      return [...routerHelpers.mapViews(this.moduleName, this.views)].map(this.mapLink);
    },
  },
  methods: {
    mapLink(c) {
      const result = { ...c };
      result.routeName = result.component.name;
      return result;
    },
  },
};
</script>

<style scoped>
.v-application a {
  color: white;
}
</style>
